export const homeLabelsSymbol = Symbol("homeLabelsSymbol");
export const campaignsLabelsSymbol = Symbol("campaignsLabelsSymbol");
export const customersLabelsSymbol = Symbol("customersLabelsSymbol");
export const usersLabelsSymbol = Symbol("usersLabelsSymbol");
export const campaignLabelsSymbol = Symbol("campaignLabelsSymbol");
